module.exports = __webpack_public_path__ + "img/pending-balance.02c01b95.svg";